import type { CardHooks } from "./registry";
import { safeNum } from "@/lib/utils";

/**
 * Hardened Hands — Attack/Defend (Light), Power 3 / Block 1, cost 1.
 *  - Defend ability: if your HP is 10 or LESS, this gains +2 block.
 *  - Attack ability: gains Piercing when the opponent has 10 or MORE HP.
 *  - Counter ability: against a buffed attack with 5+ accumulated power
 *    bonus, strip all power-bonus buffs from the attacker (handled in
 *    counter resolution; see counter handling in playtestEngine.ts —
 *    this hook only drives onAttackPlay/onDefendPlay).
 */
export const hardenedHands: CardHooks = {
  onDefendPlay: (ctx) => {
    const { self, card } = ctx;
    if (self.health > 10) return {};
    const baseBlock = safeNum(card.attackDefendFields?.blockValue ?? 0);
    const overrides = new Map(self.adValueOverrides);
    overrides.set(card.id, baseBlock + 2);
    return {
      selfPatch: { adValueOverrides: overrides },
      log: [`Hardened Hands — HP ${self.health} ≤ 10, +2 block`],
    };
  },
  onAttackPlay: (ctx) => {
    const { opponent } = ctx;
    if (opponent.health < 10) return {};
    return {
      slotKeywordGrants: ["Piercing"],
      log: [`Hardened Hands — opponent HP ${opponent.health} ≥ 10, this attack gains Piercing`],
    };
  },
};
